import { Divider, Grid, Typography } from '@mui/material';
import React from 'react';
import { useTheme } from "@mui/material/styles";
import ExitReasonGrid from '../../../Ancillary/ECMS/views/ExitReason';
import ClearanceDepartmentGrid from '../../../Ancillary/ECMS/views/ClearanceDepartment';


const ECMSConfigLandingPage = ({accordian}) => {
    const theme = useTheme();
    const values = [
        { name: "Asset Configuration", comp: <ClearanceDepartmentGrid /> },
        { name: "Exit Reason Configuration", comp: <ExitReasonGrid />},
    ];

    return (
        <Grid container spacing={2} style={{ padding: "10px 0px" }}>
            {values?.map((value, id) => (
              <React.Fragment key={id}>
                <Grid
                    item
                    xs={12}
                    md={value.name === "Tax Controls" ? 12 : 6}
                    >
                    <Typography
                        variant="h6"
                        gutterBottom
                        sx={{
                        paddingLeft: "15px",
                        color: theme.palette.primary.contrastText,
                        }}
                    >
                        {value.name}
                    </Typography>
                    {value?.comp}
                </Grid>
                {([1, 2, 3].includes(id)) && (
                    <Grid item xs={12}>
                        <Divider sx={{ my: 1 }} />
                    </Grid>
                )}
              </React.Fragment>

            ))}
        </Grid>
    );
};

export default ECMSConfigLandingPage;
